<template>
  <jtn-ui-record-image
    v-observe-visibility="imageVisibility.getOptions('half')"
    :class="$style['record-main-image']"
    :author="mainImageInfo.author"
    :caption="mainImageInfo.description"
    :authorLabel="authorLabel"
    :display-caption="displayCaption"
  >
    <div
      :class="$style.vox"
      slot="image"
      ref="vox"
      :data-hyb-ssp-in-image-overlay="idAdvVOX"
    >
      <JtnUiImage
        :class="[$style.recordImg, 'responsive-image']"
        :src="mainImageData.img.src"
        :sources="mainImageData.sources"
        :hasCommercialLabel="mainImageData.hasCommercialLabel"
        :loading="mainImageData.img.loading"
        fetchPriority="high"
        :decoding="mainImageData.img.decoding"
        :aspectRatio="3 / 2"
        :sizes="mainImageData.img.sizes"
        :srcset="mainImageData.img.srcset"
        :placeholderImg="mainImageData.placeholderImg"
        @click="onImageClicked"
      />
      <AdvCreative
        v-if="isShowInImageCreative"
        :adv="inImageAdvBlock"
        :clientRender="true"
        :index="index"
        :class="[$style.inImageButton]"
      />
      <link itemprop="contentUrl" :href="mainImageData.img.src" />
    </div>

    <jtn-ui-share
      slot="share"
      :btn-size="36"
      :is-popup="true"
      :socials="['vk', 'twitter', 'ok', 'telegram', 'wa']"
      :copy-link="shareLink"
      :popup-position="'bottom-left'"
      @shared="shareImage($event)"
      @linkCopied="shareImage('link')"
    />
  </jtn-ui-record-image>
</template>

<script>
import { smoothScroll } from '@jtnews/shared/smooth-scroll';
import { JtnUiRecordImage } from '@jtn-ui/components/record';
import { JtnUiShare, JtnUiPicture, JtnUiImage } from '@jtnews/jtn-ui';
import { AdvCreative } from '../../../../shared/components/_adv';
import {
  ObserverVisibility,
  EntityDecoderMixin,
  generateImageUrl,
  StoreMixin
} from '@jtnews/shared';

export default {
  name: 'RecordMainImage',
  components: { JtnUiRecordImage, JtnUiShare, JtnUiPicture, JtnUiImage, AdvCreative },
  mixins: [EntityDecoderMixin, StoreMixin],
  props: {
    mainImageData: {
      type: Object,
      default() {
        return {};
      }
    },
    mainImageInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    displayCaption: {
      type: Boolean,
      default: true
    },
    authorLabel: {
      string: String,
      default: 'Фото'
    },
    shareLink: {
      type: String,
      default: ''
    },
    idAdvVOX: {
      type: String,
      default: ''
    },
    index: {
      type: Number,
      default: undefined
    }
  },
  data() {
    return {
      imageVisibility: new ObserverVisibility('half'),
      isEmptyVoxAdv: false
    };
  },
  computed: {
    inImageAdvBlock() {
      return this.store.advModule.inImageAdvBlock;
    },
    isShowInImageCreative() {
      return this.inImageAdvBlock && this.isEmptyVoxAdv;
    }
  },
  beforeMount() {
    this.voxObserver = new MutationObserver(mutations => {
      mutations.forEach(mutation => {
        if (mutation.attributeName === 'data-hyb-ssp-ad-place-status') {
          const attrValue =
            this.$refs.vox.attributes['data-hyb-ssp-ad-place-status'].value;
          if (attrValue === 'empty') {
            this.isEmptyVoxAdv = true;
          }
        }
      });
    });
  },
  mounted() {
    this.$nextTick(() => {
      const imageId = this.$route.query.shareRecordImage;
      if (imageId === this.mainImageInfo?.id) {
        this.scrollToImage();
      }
    });

    this.imageVisibility.event.subscribe(state => {
      if (state.value) {
        this.$emit('onImageVisible');
      }
    });

    this.voxObserver.observe(this.$refs.vox, { attributes: true });
  },
  beforeDestroy() {
    this.imageVisibility.destroy();
  },
  methods: {
    onImageClicked() {
      this.$emit('imageClicked', this.mainImageInfo.id);
    },
    scrollToImage() {
      setTimeout(() => {
        const clientRect = this.$el.getBoundingClientRect();
        const top = clientRect.top + window.pageYOffset;

        smoothScroll(top, 300);
      }, 700);
    },
    shareImage($event) {
      this.$emit('shareClicked', $event);
    }
  }
};
</script>

<style lang="scss" module>
@import 'styles';

.record-main-image {
  display: block;

  margin: 24px $central-column-mobile-padding-negative 18px;

  @include on-min-resize($tablet) {
    margin: 40px auto 18px;
  }

  img {
    display: inline-block;

    width: 100%;
    height: auto;
    max-height: none;

    cursor: pointer;
  }
}

.recordImg {
  width: 100%;
}

.vox {
  position: relative;
}

.inImageButton {
  position: absolute;
  right: 0;
  bottom: 0;

  width: auto;
  overflow: visible;

  & > div {
    min-width: auto;
  }
}
</style>
